import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import PropTypes from 'prop-types';
import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import entityComposition from '../common/classes/entityComposition';
const ModalNotification = _ref => {
  let list = _ref.list;
  if (list.length === 0) {
    return null;
  }
  const _list = _slicedToArray(list, 1),
    content = _list[0].content;
  const buttons = ['left', 'middle', 'right'].map(direction => {
    const label = content["".concat(direction, "ButtonLabel")];
    const action = content["".concat(direction, "ButtonAction")];
    const color = content["".concat(direction, "ButtonColor")];
    if (!label) return undefined;
    return /*#__PURE__*/React.createElement(Button, {
      key: "btn-".concat(label),
      color: color,
      onClick: () => action()
    }, label);
  });
  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: true,
    style: {
      maxWidth: '800px'
    }
  }, /*#__PURE__*/React.createElement(ModalHeader, null, content.headerMessage), /*#__PURE__*/React.createElement(ModalBody, {
    style: {
      whiteSpace: 'pre-line',
      wordBreak: 'break-word'
    }
  }, content.message), /*#__PURE__*/React.createElement(ModalFooter, null, buttons));
};
ModalNotification.propTypes = {
  notificationActions: PropTypes.shape({
    dismiss: PropTypes.func
  }).isRequired,
  list: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};
export { ModalNotification as TestModalNotification };
export default entityComposition(ModalNotification, [], {}, ['notification']);